<mat-card class="configuration-card terminal-devices-card">
  <mat-card-header>
    <mat-card-title class="devices-card-title">
      <div class="devices-title-text">
        <mat-icon class="section-icon">point_of_sale</mat-icon>
        <div>
          <span class="devices-heading">Terminal Devices</span>
          <p class="devices-sub">Paired card readers available for in-person payments.</p>
        </div>
      </div>
      <button mat-stroked-button type="button" (click)="loadStripeDevices()">
        <mat-icon>refresh</mat-icon> Refresh
      </button>
    </mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <div *ngIf="!isSquareAuthorized" class="inline-banner banner-warning">
      <mat-icon>info</mat-icon>
      <div class="banner-body">
        <strong>Not connected to Square</strong>
        <span>Authorize your Square account above to see paired terminals.</span>
      </div>
    </div>

    <mat-progress-spinner *ngIf="showProgressSpinner"
      class="device-spinner"
      mode="indeterminate"
      diameter="34">
    </mat-progress-spinner>

    <div *ngIf="errorMessage" class="inline-banner banner-error">
      <mat-icon>error_outline</mat-icon>
      <div class="banner-body">
        <strong>Couldn’t load devices</strong>
        <span>{{ errorMessage }}</span>
      </div>
      <button mat-stroked-button type="button" class="banner-retry" (click)="loadStripeDevices()">
        <mat-icon>refresh</mat-icon> Retry
      </button>
    </div>

    <ng-container *ngIf="isSquareAuthorized && !errorMessage && !showProgressSpinner">

      <!-- Active terminals -->
      <div class="terminal-group">
        <div class="group-label">
          <span>Active</span>
          <span class="group-count">{{ activeDevices.length }}</span>
        </div>

        <div class="device-grid" *ngIf="activeDevices.length > 0">
          <div *ngFor="let device of activeDevices"
               class="device-tile"
               [ngClass]="{'selected': selectedDeviceId === device.id}"
               (click)="selectDevice(device.id)">
            <span class="tile-label">{{ device.attributes.name }}</span>
            <span class="tile-subtext">{{ device.attributes.model }} - {{ device.attributes.version }}</span>
            <div class="device-details">
              <p>Battery: {{ device.battery }}%</p>
              <p *ngIf="device.wifi">
                {{ device.wifi.ssid }}
                <mat-icon [ngClass]="'wifi-strength-' + device.wifi.signal_strength.value">
                  {{ device.wifi.signal_strength.value === 0 ? 'wifi_off' : 'wifi' }}
                </mat-icon>
              </p>
              <p *ngIf="!device.wifi">Ethernet Connected</p>
            </div>
            <span class="device-status">{{ device.status.category }}</span>
          </div>
        </div>

        <div class="empty-state" *ngIf="activeDevices.length === 0">
          <mat-icon>point_of_sale</mat-icon>
          <p>No active terminals</p>
          <span>Pair a reader with “Add Terminal Device” above to get started.</span>
        </div>
      </div>

      <!-- Inactive terminals -->
      <div class="terminal-group">
        <div class="group-label">
          <span>Inactive</span>
          <span class="group-count">{{ inactiveDevices.length }}</span>
        </div>

        <div class="device-grid" *ngIf="inactiveDevices.length > 0">
          <div *ngFor="let device of inactiveDevices"
               class="device-tile is-inactive"
               [ngClass]="{'selected': selectedDeviceId === device.id}"
               (click)="selectDevice(device.id)">
            <span class="tile-label">{{ device.attributes.name }}</span>
            <span class="tile-subtext">{{ device.attributes.model }} - {{ device.attributes.version }}</span>
            <div class="device-details">
              <p>Battery: {{ device.battery }}%</p>
              <p *ngIf="device.wifi">
                {{ device.wifi.ssid }}
                <mat-icon [ngClass]="'wifi-strength-' + device.wifi.signal_strength.value">
                  {{ device.wifi.signal_strength.value === 0 ? 'wifi_off' : 'wifi' }}
                </mat-icon>
              </p>
              <p *ngIf="!device.wifi">Ethernet Connected</p>
            </div>
            <span class="device-status">{{ device.status.category }}</span>
          </div>
        </div>

        <div class="empty-state" *ngIf="inactiveDevices.length === 0">
          <mat-icon>power_off</mat-icon>
          <p>No inactive terminals</p>
          <span>Devices that go offline will appear here.</span>
        </div>
      </div>

    </ng-container>
  </mat-card-content>
</mat-card>
